export default __webpack_public_path__ + "static/media/close-pop-up.c497331e.svg";